import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { ReactComponent as DialogCheck } from "../assets/images/dialog-alert.svg";
import CloseIcon from "../assets/images/plus-circle-fill.svg";

const useStyles = makeStyles({
  colorButton: {
    color: "red",
  }
});
const styles = {
  containerDialog: {
    padding: "56px 24px 42px 24px"
  }
}
const AlertTypeFile = (props) => {
  const { t } = useTranslation();
  const handleClose = () => {
    props.setValue(false)
  };
  const classes = useStyles();
  return (
    <React.Fragment>
      <Dialog
        onBackdropClick={() => {return false}}
        open={props.open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={styles.containerDialog}>
          <Box sx={{ position: "absolute", right: 0, margin: "20px 20px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
            <DialogCheck></DialogCheck>
            <Typography color="#CC6058" variant="h3" mt={3}>{t(`label.uploadFailed`)}</Typography>
            <Typography textAlign="center" mt={2} dangerouslySetInnerHTML={{ __html: props.text }}></Typography>
            <Typography textAlign="center" dangerouslySetInnerHTML={{ __html: props.textSub }}></Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 56 }}>
          <Button onClick={handleClose} size="large" variant="contained" sx={{ width: '300px', color: "#fff!important", backgroundColor: '#CC6058', fontSize: '18px', lineHeight: '19.8px', paddingTop: '18px', paddingBottom: '18px' }} color="red">{t(`label.TryAgain`)}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default AlertTypeFile;